import dayjs from "dayjs";

export const formatBirthDateTime = (timeStr: string | undefined): dayjs.Dayjs | undefined => {
    if (!timeStr) return undefined;

    console.log('Input time:', timeStr);
    let dateTime = dayjs(timeStr);
    if (!dateTime.isValid()) {
        dateTime = dayjs('2000-01-01 ' + timeStr);
    }
    console.log('Parsed datetime:', dateTime.format('YYYY-MM-DD HH:mm:ss'));

    if (!dateTime.isValid()) {
        console.log('Invalid datetime parsing');
        return undefined;
    }

    return dateTime;
};
